import RegularFopElementsFactory from './RegularFopElementsFactory';
import { containerTypes } from 'apps/analytics';

export default class RecommendedFopElementsFactory extends RegularFopElementsFactory {
  constructor(...args) {
    super(...args);
    this.hasQuickMenu = false;
  }

  getFopTypeClass = () => 'fops-yml';

  getContainerType = () => containerTypes.RECOMMENDED;
}
